import { CommonModule } from '@angular/common';
import { Component, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownComponent } from 'src/app/components/shared/dropdown/dropdown.component';
import { ResumeEducationStatus } from 'src/app/enums/resume-education-status';
import { ResumeEducation } from 'src/app/models/resume/resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-education',
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: './modal-education.component.html',
  styleUrl: './modal-education.component.css'
})
export class ModalEducationComponent implements OnInit, OnDestroy {
  public resumeId = input<number | null>(null);
  public onResumeEducation = output<ResumeEducation>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    educationLevelId: new FormControl(null, [Validators.required]),
    careerId: new FormControl(null, [Validators.required]),
    institutionId: new FormControl(null, [Validators.required]),
    fieldStudy: new FormControl('', [Validators.maxLength(1000)]),
    description: new FormControl('', [Validators.maxLength(1000)]),
    resumeEducationStatusId: new FormControl(null, [Validators.required]),
    startDate: new FormControl(null, [Validators.required]),
    endDate: new FormControl(null),
    isEnabled: new FormControl(true)
  });

  isLoading = signal<boolean>(false);

  educationLevels: DropdownOption[] = [];
  careers: DropdownOption[] = [];
  institutions: DropdownOption[] = [];
  resumeEducationStatus: DropdownOption[] = [];

  resumeEducationStatusEnum = ResumeEducationStatus;

  subscription: Subscription | undefined;

  ngOnInit(): void {
    this.getOptions();
    this.subscription = this.form.get('educationLevelId')?.valueChanges.subscribe(() => {
      this.changeEducationLevel();
    });
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.EducationLevels,null,undefined,true).subscribe({
      next: res => {
        this.educationLevels = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Universities,null,undefined,true).subscribe({
      next: res => {
        this.institutions = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.ResumeEducationStatus,null,undefined,true).subscribe({
      next: res => {
        this.resumeEducationStatus = res;
      }
    });
  }

  changeStatus() {
    const resumeEducationStatusId = this.form.get('resumeEducationStatusId')?.value;
    if (!resumeEducationStatusId) {
      return;
    }
    if (resumeEducationStatusId == this.resumeEducationStatusEnum.Completed) {
      this.form.get('endDate')?.setValidators([Validators.required]);
    }
    else {
      this.form.get('endDate')?.clearValidators();
    }
    this.form.get('endDate')?.updateValueAndValidity();
  }

  changeEducationLevel() {
    const educationLevelId = this.form.get('educationLevelId')?.value;
    if (educationLevelId) {
      this.dropdownService.GetOptions(DropDownKeywords.Careers, educationLevelId,undefined,true).subscribe({
        next: res => {
          this.careers = res;
        }
      });
    }else{
        this.careers = [];
    }
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      isEnabled: true
    });
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById('modalEducation');
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const resumeEducation = {
      ...this.form.getRawValue(),
      resumeId: this.resumeId(),
      institution: this.institutions?.find(x => x.id == this.form.get('institutionId')?.value)?.text,
      educationLevel: this.educationLevels?.find(x => x.id == this.form.get('educationLevelId')?.value)?.text,
      career: this.careers?.find(x => x.id == this.form.get('careerId')?.value)?.text,
      resumeEducationStatus: this.resumeEducationStatus?.find(x => x.id == this.form.get('resumeEducationStatusId')?.value)?.text,
    } as any as ResumeEducation;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeEducation({
        ...resumeEducation
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeEducation.emit(resumeEducation)
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeEducation.emit(resumeEducation);
      this.closeModal();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}